import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31850c92"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "prompt-content__title prompt-content__title--noTips" }, /*#__PURE__*/_toDisplayString('该空间已设置权限，请登录后使用'), -1))
const _hoisted_2 = { class: "prompt-content__button" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("登录账号")

import { NButton } from 'naive-ui'
import { useAccountChange } from '@teams/common/hooks/useAccountChange'

export default /*#__PURE__*/_defineComponent({
  __name: 'notLoginPrivate',
  setup(__props) {

const { onLogin } = useAccountChange()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NButton), {
        type: "primary",
        onClick: _unref(onLogin)
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}
}

})